import React from 'react'
import {
    makeStyles, 
    TableContainer, Table, TableCell, TableRow,TableHead,TableBody} from '@material-ui/core';

    const useStyles = makeStyles((theme) => ({ 
        tituloTable: {
    
            backgroundColor: '#e6e6e6', 
           minWidth: 200,
           color: 'white',
           textAlign: 'black',
           padding: '10px',
           fontWeight: '250',
           fontSize : '16px'
        },  
        TituloIdentificacion: {
    
           backgroundColor: theme.palette.primary.main, 
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '15px',
           fontWeight: '250',
           fontSize : '18px',
           height: 'auto',
           alignContent: 'center',               
        },
        FondoTable :{
       
            backgroundColor: theme.palette.greyFondo.main
        },
    }));

const TblDocumentoProtestado = () => {
    const classes = useStyles();


    return (
        <div>

          
            <TableContainer>
            <Table>
            <TableHead className={classes.FondoTable}>
                <TableRow>
                    <TableCell> Cantidad de Cheques</TableCell>
                    <TableCell>0</TableCell>
                    
                    
                </TableRow>
            </TableHead>
            <TableBody>
                           
              <TableRow>
              <TableCell>Montos de Cheques	</TableCell>
              <TableCell>0</TableCell>
              </TableRow>
              </TableBody>
            </Table>
    
        </TableContainer>
        </div>
    )
}

export default TblDocumentoProtestado